<div class="modal-header">
    <h5 class="modal-title">Select Folder</h5>
    <span class="fa fa-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></span>
</div>
<div class="modal-body">
    <div class="row flat">
        <div class="col-3">
            <li class="route-list" (click)="getFolderData(route)" [ngClass]="{'selected': selectedRoute == route?.type}" *ngFor="let route of routeList">{{route.name}}</li>
        </div>
        <div class="col">
            <concourse-folder-treeview [canEdit]="canEdit" [type]="selectedRoute" [projectId]="projectId" (onSelectFolder)="onSelectFolder($event)" [selectedItem]="selectedItem"></concourse-folder-treeview>
            <hr>
            <div class="form-group">
                <label for="">Report Name (Optional)</label>
                <input [(ngModel)]="reportName" type="text" class="form-control w-100" placeholder="Enter report name (Optional)">
              </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="!selectedItem?.value"
        (click)="saveToFolder(reportName)">Save to folder</button>
    <button type="button" class="btn btn-default" (click)="activeModal.close()">Cancel</button>
</div>